var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ProjectsHeader'),_c('ProjectsIntro'),_c('ProjectsIndex'),_c('ProjectsDone'),_c('ProjectsMore'),_c('NavigationCta')],1)}
var staticRenderFns = []

export { render, staticRenderFns }